import { PostMessage, PostMessageType } from '@spazious/search-sdk-types';

type MessageCallback<T = any> = (payload: T, event: MessageEvent) => void;

const messageHandlers: Record<string, Set<MessageCallback>> = {};

export const registerMessageHandler = <T = any>(
  type: PostMessageType,
  callback: MessageCallback<T>
) => {
  if (!messageHandlers[type]) {
    messageHandlers[type] = new Set();
  }
  messageHandlers[type].add(callback);
};

export const unregisterMessageHandler = <T = any>(
  type: PostMessageType,
  callback: MessageCallback<T>
) => {
  messageHandlers[type]?.delete(callback);
};
const globalMessageListener = (event: MessageEvent<PostMessage>) => {
  const data = event.data;

  // Check if the message has payload or not
  if (data) {
    switch (data.type) {
      case PostMessageType.INIT_CONFIG:
      case PostMessageType.EXPANSION_STARTED:
      case PostMessageType.EXPANDED:
      case PostMessageType.RESET:
      case PostMessageType.RESET_COMPLETED:
        // These message types have a payload
        const { payload } = data;
        messageHandlers[data.type]?.forEach((cb) => cb(payload, event));
        break;

      default:
        break;
    }
  }
};

let isListening = false;

export const startGlobalMessageListener = () => {
  if (!isListening) {
    window.addEventListener('message', globalMessageListener);
    isListening = true;
  }
};

export const stopGlobalMessageListener = () => {
  if (isListening) {
    window.removeEventListener('message', globalMessageListener);
    isListening = false;
  }
};
